// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"59537b79","549":"2f464b5b"}[chunkId] + ".chunk.js";
};